import { CalibrationPointsConfig } from '../../sensors/types';

export interface FrequencyTemperatureRow {
  key: string;
  label: string;
  placeholder: string;
}

interface SchemaConfigLike {
  calibrationPoints: CalibrationPointsConfig;
  generatePlaceholder: (point: number, sequence?: 'inc' | 'dec' | 'inc2') => string;
}

/** Frequency rows in entry order: BOL, AOL, increasing, decreasing, second-increasing. */
export const buildFrequencyRows = (schemaConfig: SchemaConfigLike): FrequencyTemperatureRow[] => {
  const points = schemaConfig.calibrationPoints;
  const rows: FrequencyTemperatureRow[] = [
    { key: 'BOL', label: 'BOL', placeholder: 'e.g., 1234.56' },
    { key: 'AOL', label: 'AOL', placeholder: 'e.g., 2456.78' },
  ];
  points.increasing.forEach((point) => {
    const p = point.toString().replace(/\./g, '_');
    rows.push({
      key: `point_${p}_inc`,
      label: String(point),
      placeholder: `e.g., ${schemaConfig.generatePlaceholder(point, 'inc')}`,
    });
  });
  points.decreasing.forEach((point) => {
    const key = Math.abs(point - 0) < 0.0001 ? 'point_0' : `point_${point.toString().replace(/\./g, '_')}_dec`;
    rows.push({
      key,
      label: String(point),
      placeholder: `e.g., ${schemaConfig.generatePlaceholder(point, 'dec')}`,
    });
  });
  points.secondIncreasing.forEach((point) => {
    const p = point.toString().replace(/\./g, '_');
    rows.push({
      key: `point_${p}_inc2`,
      label: String(point),
      placeholder: `e.g., ${schemaConfig.generatePlaceholder(point, 'inc2')}`,
    });
  });
  return rows;
};

export const buildTemperatureRows = (): FrequencyTemperatureRow[] => [
  { key: 'roomT', label: 'Room T', placeholder: 'e.g., 23.4' },
  { key: 'highT', label: 'High T', placeholder: 'e.g., 60.0' },
  { key: 'roomF', label: 'Room F', placeholder: 'e.g., 23.1' },
  { key: 'highTempF', label: 'High temp F', placeholder: 'e.g., 60.2' },
];
